import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthService from "../../services/auth.service";

export const requestLoginOtp = createAsyncThunk(
  "auth/requestLoginOtp",
  async ({ uname }, thunkAPI) => {
    try {
      const data = await AuthService.requestLoginOtp({ uname }); //  FIX
      return data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error.message ||
        "Failed to send OTP";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const register = createAsyncThunk(
  "auth/register",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.register(item);
      return { user: data };
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error.message ||
        "Registration failed";
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const otpConfirmation = createAsyncThunk(
  "auth/otpConfirmation",
  async ({ email, mobileNumber, otp }, thunkAPI) => {
    try {
      const res = await AuthService.otpVerification({
        email,
        mobileNumber,
        otp,
      });

      const user = res?.data; // ✅ FIX

      return user;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error.message ||
        "OTP verification failed";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getProfile = createAsyncThunk(
  "auth/getProfile",
  async (_, thunkAPI) => {
    try {
      const res = await AuthService.getProfile();
      return res.data; //  return ONLY user object
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error.message ||
        "Failed to fetch profile";
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const logout = createAsyncThunk("auth/logout", async () => {
  AuthService.removeUserDetails();
});

/* ===================== INITIAL STATE ===================== */

const storedUser = AuthService.getUserDetails();

const initialState = {
  loading: false,
  error: "",
  user: storedUser,
  isLoggedIn: !!storedUser, //  persists correctly
};

/* ===================== SLICE ===================== */

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      /* ---------- REQUEST LOGIN OTP ---------- */
      .addCase(requestLoginOtp.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(requestLoginOtp.fulfilled, (state) => {
        state.loading = false;
        //  DO NOT SET isLoggedIn
      })
      .addCase(requestLoginOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- REGISTER ---------- */
      .addCase(register.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(register.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
      })
      .addCase(register.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- OTP CONFIRMATION (LOGIN HERE) ---------- */
      .addCase(otpConfirmation.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(otpConfirmation.fulfilled, (state, action) => {
        state.loading = false;
        state.isLoggedIn = true; //  ONLY HERE
        state.user = action.payload;
      })
      .addCase(otpConfirmation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      /* ---------- GET PROFILE ---------- */
.addCase(getProfile.pending, (state) => {
  state.loading = true;
  state.error = "";
})
.addCase(getProfile.fulfilled, (state, action) => {
  state.loading = false;

  // 🔥 merge profile into existing user (token stays)
  state.user = {
    ...state.user,
    data: action.payload,
  };
})
.addCase(getProfile.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload;
})

      /* ---------- LOGOUT ---------- */
      .addCase(logout.fulfilled, (state) => {
        state.isLoggedIn = false;
        state.user = null;
        state.error = "";
      });
  },
});

export default authSlice.reducer;
